import BusinessEntity, { EntityManager } from '@xFrame4/business/BusinessEntity';
import User from '@xFrame4/business/User';

/**
 * A contact message sent either by an user or a anonymous user.
 */
export class ContactMessage extends BusinessEntity
{
    dateAdded!: string
    user: User | null = null;
    name: string = '';
    email: string = '';
    phone: string = '';
    message: string = '';
    source: string = '';
    
    static manager: EntityManager<ContactMessage> = new EntityManager<ContactMessage>({
        name: 'ContactMessage',
        createEntity: () => new ContactMessage(),
        fields: [
            { name: 'dateAdded', isInput: false},
            { name: 'user', inputName: 'userId', inputProperty: 'user.id', relatedManager: User.manager },
            { name: 'name' },
            { name: 'email' },
            { name: 'phone' },
            { name: 'message', isRequiredInput: true },
            { name: 'source' },
        ],
        graphQlQueryAlias: 'contactMessages',
    });
}

export default ContactMessage;